import { HTTP } from './config-axios';
export default {
    unsubscribe: async token => await HTTP.get(`unsubscribe/${token}`),
};
